import { render, staticRenderFns } from "./BackStatistics.vue?vue&type=template&id=1785ca0a&scoped=true&"
import script from "./BackStatistics.vue?vue&type=script&lang=js&"
export * from "./BackStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BackStatistics.vue?vue&type=style&index=0&id=1785ca0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785ca0a",
  null
  
)

export default component.exports